import useBottomSheet from '@hooks/ui/useBottomSheet';
import { useState, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import UpdateNameBottomSheet from '../UpdateNameBottomSheet';

interface Props {
    id: string;
    initialValue: string;
}

function useUpdateName({ id, initialValue }:Props) {
    const { t } = useTranslation('prepaidCard');
    const [name, setName] = useState<string>(initialValue);
    const { openBottomSheet } = useBottomSheet();
    const handleUpdateName = (e: MouseEvent<HTMLOrSVGElement>) => {
        e.preventDefault();
        e.stopPropagation();
        openBottomSheet(
            t('manage.updateName.bottomSheetTitle'),
            <UpdateNameBottomSheet initialValue={initialValue}
                id={id}
                name={name}
                setName={setName} />,
        );
    };
    return {
        name, handleUpdateName,
    };
}

export default useUpdateName;
